import { render, staticRenderFns } from "./difficultProblems.vue?vue&type=template&id=7c69e7d9&scoped=true"
import script from "./difficultProblems.vue?vue&type=script&lang=js"
export * from "./difficultProblems.vue?vue&type=script&lang=js"
import style0 from "./difficultProblems.vue?vue&type=style&index=0&id=7c69e7d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c69e7d9",
  null
  
)

export default component.exports